import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../../components/Title";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Message from "../../tools/Message";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { userDetailContext } from "../../../App";
import { useContext } from "react";
import Spacer from "../../../components/Spacer";
import { useNavigate } from 'react-router-dom';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Typography from '@mui/material/Typography';
import TextField from "@material-ui/core/TextField";
import TDRService from "../../../services/TDRService";
import MainContainer from "../../../components/MainContainer";
import { headerDataMission } from "../../../data/modules/mission-header";
import LoadingButton from '@mui/lab/LoadingButton';
import MissionService from "../../../services/MissionService";
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import MissionOrderService from "../../../services/MissionOrderService";
import Box from '@mui/material/Box';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PlanningMissionDetail() {
  const classes = useStyles();
  const noteStyle = {
    backgroundColor: '#d4edda', 
    color: '#155724',            
    borderRadius: '5px',
    border: '1px solid #c3e6cb',
    maxWidth: '100%',
    textAlign: 'center',
    margin: '0' 
  };

  const noteStyleerreur = {
    backgroundColor: '#e43a06',           
    borderRadius: '5px',
    border: '1px solid #c3e6cb',
    width: '100%',         
    textAlign: 'center',
    padding: '10px 0',    
    boxSizing: 'border-box' 
  };

  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const [loading, setLoading] = useState(false);
  const [loadingenrg, setLoadingenrg] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const segments = pathname.split('/');
  const missionId = segments[segments.length - 1];
  const [form, setForm] = useState({
    mission_id: missionId,
    tdr_id: "",
    agenda_id: ""
  });
  
  const handleClose = () => {
    navigate('/mission/planning_mission');
  };
  
  const [openDialogKilometer, setOpenDialogKilometer] = useState({
    open: false,
    mission_planning_id : missionId,
  });

  const handleClosealert = () => {
    setErroraffiche(false);
  };

  const contextData = useContext(userDetailContext);
  const [details, setDetails] = useState([]);
  const [tdrinit, setTDRinit] = useState({});
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  const [tdr, setTDR] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const [affiche, setAffiche] = useState(false);
  const [agendasParDestination, setAgendasParDestination] = useState({});
  const [agendasDetailsMap, setAgendasDetailsMap] = useState({});
  const [agendasDetailDateMap, setAgendasDetailDateMap] = useState({});
  const [intervenantsoption, setIntervenantoption] = useState([]);
  const [detaildateplanning, setDetailsdateplanning] = useState({});
  const [erroraffiche, setErroraffiche] = useState(false);
  const [missionnaires, setMissionnaires] = useState([]);

  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['application/pdf', 'application/zip', 'application/x-rar-compressed'];
      if (allowedTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        setError(null);
      } else {
        setError("Seuls les fichiers PDF, ZIP et RAR sont autorisés.");
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const objectToArray = (obj) => {
    if (!obj) return [];
    if (Array.isArray(obj)) return obj;
    if (typeof obj === 'object') {
      return Object.values(obj);
    }
    return [];
  };

  const initializeParticipants = (agendaDetails, missionnairesList, categtype) => {
      if (!agendaDetails) return {};
      
      const updatedDetails = { ...agendaDetails };
      
      Object.keys(updatedDetails).forEach(key => {
          const element = updatedDetails[key];
          if (element && typeof element === 'object') { 
              if (categtype === 'groupe') {
                  const hasNoUserId = !element.user_id || 
                                  (Array.isArray(element.user_id) && element.user_id.length === 0);
                  if (hasNoUserId) {
                      element.user_id = missionnairesList;
                  }
              } 
              
              const hasNoParticip = !element.user_id || 
                                  (Array.isArray(element.user_id) && element.user_id.length === 0);
                                  
              if (hasNoParticip) {
                  element.user_id = missionnairesList;
              }
          }
      });
      
      return updatedDetails;
  };

  const isDateRangeValid = (planningDate, agendaDates) => {
    if (!planningDate || !agendaDates) return false;
    
    if (agendaDates.date_begin && agendaDates.date_end) {
      return (
        planningDate.date_begin === agendaDates.date_begin &&
        planningDate.date_end === agendaDates.date_end
      );
    }
    
    return false;
  };

  const validateAllDates = () => {
    if (!detaildateplanning || Object.keys(agendasDetailDateMap).length === 0) {
      return false;
    }

    const minDateBegin = Object.values(agendasDetailDateMap).reduce((min, agenda) => {
      return agenda.date_begin < min ? agenda.date_begin : min;
    }, Object.values(agendasDetailDateMap)[0].date_begin);
    
    const maxDateEnd = Object.values(agendasDetailDateMap).reduce((max, agenda) => {
      return agenda.date_end > max ? agenda.date_end : max;
    }, Object.values(agendasDetailDateMap)[0].date_end);
    
    
    return (
      minDateBegin >= detaildateplanning.date_begin &&
      maxDateEnd <= detaildateplanning.date_end
    );
  };

  useEffect(() => {
    let isMounted = true;
    setLoadingData(true);

    const fetchData = async () => {
      try {
        const tdrResult = await TDRService.geTDR();
        if (isMounted && tdrResult && tdrResult.data) {
          setTDR(tdrResult.data?.map((row) => ({ ...row, id: row.tdr_mission_id })));
        }

        const agendaResult = await TDRService.getagendasimple();
        if (isMounted && agendaResult && agendaResult.data) {     
          setAgenda(agendaResult.data?.map((row) => ({ ...row, id: row.id })));
        }

        const planningDateResult = await MissionService.planningdate(missionId);
        if (isMounted && planningDateResult && planningDateResult.data) {
          setDetailsdateplanning(planningDateResult.data);
        }
        
        const detailsResult = await PlanningMissionService.getdetails(missionId);
        if (isMounted && detailsResult && detailsResult.data) {
          setDetails(detailsResult.data);
          setAffiche(true);
          setTDRinit(detailsResult.data[0].tdrref);
          setForm({ ...form, tdr_id: detailsResult.data[0].tdrref ? detailsResult.data[0].tdrref.tdr_mission_id : "" });
          
          const missionnairesList = detailsResult.data[0].missionnary || [];
          setMissionnaires(missionnairesList);
          
          const intervenants = JSON.parse(detailsResult.data[0].intervenant);
          setIntervenantoption(intervenants.map((name) => ({ user_id: name, nom: name })));
          
          const initialAgendasParDestination = {};
          
          if (detailsResult.data[0].destination && detailsResult.data[0].destination.length > 0) {
            detailsResult.data[0].destination.forEach((dest) => {
              const destinationAgendas = detailsResult.data[0].agedref ? 
                detailsResult.data[0].agedref.filter(agenda => 
                  agenda.mission_planning_destination_id === dest.planning_destination
                ) : [];
              
              initialAgendasParDestination[dest.planning_destination] = destinationAgendas;
              
              destinationAgendas.forEach(agendaItem => {
                if (agendaItem?.id) {
                  TDRService.getagendadetails(agendaItem.id)
                    .then((res) => {
                      if (isMounted && res?.data) {
                        const processedData = initializeParticipants(
                          res.data, 
                          missionnairesList, 
                          detailsResult.data[0].categtype
                        );
                        
                        if (res.detail) {
                          setAgendasDetailDateMap(prev => ({
                            ...prev,
                            [agendaItem.id]: res.detail
                          }));
                        }
                        
                        setAgendasDetailsMap(prev => ({
                          ...prev,
                          [agendaItem.id]: processedData
                        }));
                      }
                    })
                    .catch((err) => {
                      console.error("Erreur chargement détails agenda:", err);
                    });
                }
              });
            });
          }
          
          setAgendasParDestination(initialAgendasParDestination);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        if (isMounted) {
          setMessage({ 
            ...message, 
            open: true, 
            color: 'red', 
            messageInfo: "Erreur lors du chargement des données" 
          });
        }
      } finally {
        if (isMounted) {
          setLoadingData(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [missionId]);

  function handleChangetdr(event, value) {
    if (!value) {
      setForm({ ...form, tdr_id: "" });
      setTDRinit(null);
      return;
    }
    setForm({ ...form, tdr_id: value.tdr_mission_id });
    setTDRinit(value);
  }

  const handleretour = () => {
    navigate('/mission/planning_mission/validate/add/' + missionId); 
  };

  const handleChangeagenda = (destinationIndex, destinationId, event, value) => {
    if (!value) return;
    
    setAgendasParDestination(prev => {
      const updatedAgendas = { ...prev };
      updatedAgendas[destinationId] = [value];
      return updatedAgendas;
    });

    if (value && value.id) {
      TDRService.getagendadetails(value.id).then((result) => {
        if (result && result.data) {
          const processedData = initializeParticipants(
            result.data, 
            missionnaires, 
            details[0]?.categtype
          );
          
          if (result.detail) {
            setAgendasDetailDateMap(prev => ({
              ...prev,
              [value.id]: result.detail
            }));
          }
          
          setAgendasDetailsMap(prev => ({
            ...prev,
            [value.id]: processedData
          }));
        }
      });
    }

    setAffiche(true);
  };

  const handlevalidate = (type) => {
    // const allDatesValid = validateAllDates();
    
    // if (!allDatesValid) {
    //   setErroraffiche(true);
    // } else {
      if (type === "validation") {
        setLoading(true);
      } else {
        setLoadingenrg(true);
      }
      
      const allAgendas = Object.values(agendasParDestination).flat();
      const firstAgendaId = allAgendas[0]?.id ?? null;
      
      TDRService.postagenda(missionId, form, allAgendas, agendasDetailsMap, type, file).then((result) => {
        if (result.status) {
          if (!firstAgendaId) {
            setMessage({ ...message, open: true, color: 'red', messageInfo: "Aucun agenda trouvé pour cette mission." });
          } else {
            setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
            navigate(
              `/mission/planning_mission/pdf/${missionId}/${firstAgendaId}`,
              { state: { firstAgendaId } }
            );
          }
        } else {
          setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
        }
        if (type === "validation") {
          setLoading(false);
        } else {
          setLoadingenrg(false);
        }
      });
    // }
  };

  const handleChangeMissionary = (event, value, agendaId, index) => {
    event.preventDefault();
  
    setAgendasDetailsMap(prev => {
      const updatedMap = { ...prev };
      const agendaDetails = updatedMap[agendaId];
      
      const agendaArray = objectToArray(agendaDetails);
      
      if (agendaArray[index]) {
        agendaArray[index] = {
          ...agendaArray[index],
          user_id: value,
        };
        
        if (!Array.isArray(agendaDetails)) {
          const keys = Object.keys(agendaDetails);
          const newObj = {};
          keys.forEach((key, i) => {
            newObj[key] = agendaArray[i] || agendaDetails[key];
          });
          updatedMap[agendaId] = newObj;
        } else {
          updatedMap[agendaId] = agendaArray;
        }
      }
      
      return updatedMap;
    });
  };
  
  const handleChangeParticipant = (event, value, agendaId, index) => {
    event.preventDefault();
  
    setAgendasDetailsMap(prev => {
      const updatedMap = { ...prev };
      const agendaDetails = updatedMap[agendaId];
      
      const agendaArray = objectToArray(agendaDetails);
      
      if (agendaArray[index]) {
        agendaArray[index] = {
          ...agendaArray[index],
          particip: value,
        };
        
        if (!Array.isArray(agendaDetails)) {
          const keys = Object.keys(agendaDetails);
          const newObj = {};
          keys.forEach((key, i) => {
            newObj[key] = agendaArray[i] || agendaDetails[key];
          });
          updatedMap[agendaId] = newObj;
        } else {
          updatedMap[agendaId] = agendaArray;
        }
      }
      
      return updatedMap;
    });
  };
  
  const handleChangetransport = (event, value, agendaId, index) => {
    event.preventDefault();
  
    setAgendasDetailsMap(prev => {
      const updatedMap = { ...prev };
      const agendaDetails = updatedMap[agendaId];
      
      const agendaArray = objectToArray(agendaDetails);
      
      if (agendaArray[index]) {
        agendaArray[index] = {
          ...agendaArray[index],
          transport: value,
        };
        
        if (!Array.isArray(agendaDetails)) {
          const keys = Object.keys(agendaDetails);
          const newObj = {};
          keys.forEach((key, i) => {
            newObj[key] = agendaArray[i] || agendaDetails[key];
          });
          updatedMap[agendaId] = newObj;
        } else {
          updatedMap[agendaId] = agendaArray;
        }
      }
      
      return updatedMap;
    });
  };

  const handleChangeObservation = (event, agendaId, index) => {
    event.preventDefault();
    const { value } = event.target;
  
    setAgendasDetailsMap(prev => {
      const updatedMap = { ...prev };
      const agendaDetails = updatedMap[agendaId];
      
      const agendaArray = objectToArray(agendaDetails);
      
      if (agendaArray[index]) {
        agendaArray[index] = {
          ...agendaArray[index],
          observation: value,
        };
        
        if (!Array.isArray(agendaDetails)) {
          const keys = Object.keys(agendaDetails);
          const newObj = {};
          keys.forEach((key, i) => {
            newObj[key] = agendaArray[i] || agendaDetails[key];
          });
          updatedMap[agendaId] = newObj;
        } else {
          updatedMap[agendaId] = agendaArray;
        }
      }
      
      return updatedMap;
    });
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const LoadingSpinner = () => (
    <MainContainer {...headerDataMission}>
      <Paper variant="outlined" style={{ marginTop: '20px', padding: '40px', textAlign: 'center' }}>
        <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ minHeight: '300px' }}>
          <Grid item xs={12}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CircularProgress size={60} thickness={4} style={{ color: '#2196F3', marginBottom: '20px' }} />
              <Typography variant="h6" color="textSecondary">
                Chargement des données en cours...
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
                Veuillez patienter
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </MainContainer>
  );

  if (loadingData) {
    return <LoadingSpinner />;
  }

  return (
    <React.Fragment>
      <MainContainer {...headerDataMission}>
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
        <Paper variant="outlined" style={{ marginTop: '20px', padding: '20px' }}>
          <Grid container spacing={2} justify="center">
            <Title style={{ textAlign: "center", marginTop: '20px', backgroundColor: '#2196F3 !important', borderRadius: '4px' }}>Informations détaillées sur la planification</Title>
          </Grid>
          <Spacer y={2} />
          {details && details.length > 0 ? (
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" align="left" >Objet de la mission :</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body1">{details[0].mission_title}</Typography>
              </Grid>
              
              <Grid item xs={2}>
                <Typography variant="body1" align="left" >Categorie :</Typography>
              </Grid>
              <Grid item xs={10}>
                {details[0].categorie && details[0].categorie.length > 0 ? 
                  details[0].categorie.map((ts, index) => (
                    <Typography key={index} variant="body1">{ts.name}{index !== details[0].categorie.length - 1 && ', '}</Typography>
                  )) 
                  : ''
                }
              </Grid>
              
              <Grid item xs={2}>
                <Typography variant="body1" align="left" >Transport :</Typography>
              </Grid>
              <Grid item xs={10}>
                {details[0].transport && details[0].transport.length > 0 ? (
                  details[0].transport.map((ts, index) => (
                    <Typography key={index} variant="body1">
                      {ts.designation}{index !== details[0].transport.length - 1 && ', '}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body1">Aucun transport</Typography>
                )}
              </Grid>
              
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="tableau des destinations">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center"></TableCell>
                          <TableCell align="center">Lieu/Direction</TableCell>
                          <TableCell align="center">Date</TableCell>
                          <TableCell align="center">Missionnaires</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {details[0].destination.map((row, index) => (
                          <TableRow
                            key={row.planning_destination}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell align="center">
                              Mission {index + 1}
                            </TableCell>
                            <TableCell align="center">
                              {row.lieu}/{row.direction}
                            </TableCell>
                            <TableCell align="center">
                              {row.date_debut} au {row.date_fin}
                            </TableCell>
                            <TableCell align="center">
                              {row.missionary && row.missionary.length > 0 ? (
                                row.missionary.map((ts, index) => (
                                  <Typography key={index} variant="body2">
                                    {ts.nom}
                                  </Typography>
                                ))
                              ) : (
                                <Typography variant="body2">Aucun missionnaire</Typography>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>

              <Grid item xs={2}>
                <Typography variant="body1" align="left" >Autre participant(s) :</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body1">
                  {
                    (() => {
                      try {
                        const partnershipArray = JSON.parse(details[0].partnership);
                        return partnershipArray.join(',');
                      } catch (e) {
                        return '';
                      }
                    })()
                  }
                </Typography>
              </Grid>

              {/* ===== TDR avec affichage corrigé + created_at ===== */}
              <Grid item xs={2}>
                <Typography variant="body1" align="left" >TDR :</Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  onChange={handleChangetdr}
                  options={tdr}
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    const title = option.title || "";
                    const reference = option.reference || "";
                    const state = option.state || "";
                    const createdAt = option.created_at || "";
                    return `${reference} - ${createdAt} ${title} ${state}`.trim();
                  }}
                  renderOption={(option) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', py: 0.5 }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 'bold', color: '#1976d2', lineHeight: 1.2 }}
                      >
                        {option.reference} - {option.created_at}
                      </Typography>
                      <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                        {option.title}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.2 }}>
                        {option.state}
                      </Typography>
                    </Box>
                  )}
                  value={tdrinit}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="TDR"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                    />
                  )}
                />
              </Grid>

              {/* ===== Agenda avec affichage corrigé + created_at ===== */}
              {details[0]?.destination?.map((row, index) => {
                const destinationAgendas = agendasParDestination[row.planning_destination] || [];
                const selectedAgenda = destinationAgendas.length > 0 ? destinationAgendas[0] : null;
              
                return (
                  <React.Fragment key={`destination-${index}-${row.planning_destination}`}>
                    <Grid item xs={2}>
                      <Typography variant="body1" align="left">
                        Agenda mission {index + 1} :
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Autocomplete
                        onChange={(event, value) => handleChangeagenda(index, row.planning_destination, event, value)}
                        options={agenda.filter((option) => option.mission_planning_id === null)}
                        getOptionLabel={(option) => {
                          if (!option) return "";
                          const title = option.title || "";
                          const reference = option.reference || "";
                          const createdAt = option.created_at || "";
                          return `${reference} - ${createdAt} ${title}`.trim();
                        }}
                        renderOption={(option) => (
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', py: 0.5 }}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 'bold', color: '#1976d2', lineHeight: 1.2 }}
                            >
                              {option.reference} - {option.created_at}
                            </Typography>
                            <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                              {option.title}
                            </Typography>
                            {option.state && (
                              <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.2 }}>
                                {option.state}
                              </Typography>
                            )}
                          </Box>
                        )}
                        value={selectedAgenda}
                        isOptionEqualToValue={(option, value) => 
                          option?.mission_agenda_id === value?.mission_agenda_id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Agenda"
                            size="small"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: 'search' }}
                          />
                        )}
                      />
                    </Grid>
                  </React.Fragment>
                );
              })}

              <Grid item xs={12}>
                <div style={noteStyle}>
                  <p>Merci de choisir le missionnaire qui participera à l'agenda, ainsi que le moyen de transport prévu pour chaque jour.</p>            
                </div>
              </Grid>

              {Object.entries(agendasParDestination).map(([destinationId, agendaList]) => (
                agendaList.map((agendaItem, agendaIndex) => {
                  const agendaDetails = agendasDetailsMap[agendaItem.id];
                  if (agendaDetails) {
                    const agendaArray = objectToArray(agendaDetails);
                    
                    return (
                      <Grid item xs={12} key={`${destinationId}-${agendaItem.id}`}>
                        <Typography variant="h6" align="left">
                          Détails de l'agenda : {agendaItem.title} ({agendaItem.reference})
                        </Typography>

                        <TableContainer component={Paper} sx={{ marginBottom: 3 }}>
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Date début</TableCell>
                                <TableCell>Date Fin</TableCell>
                                <TableCell>Heure</TableCell>
                                <TableCell>Activités</TableCell>
                                <TableCell>
                                  {details[0].categtype === 'groupe' ? 'Intervenants' : 'Participants'}
                                </TableCell>
                                {details[0].categtype === 'groupe' && <TableCell>Participants</TableCell>}
                                <TableCell>Transport</TableCell>
                                <TableCell>Observation</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {agendaArray.map((items, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {formatDate(items.date_begin)}
                                  </TableCell>
                                  <TableCell>
                                    {formatDate(items.date_end)}
                                  </TableCell>
                                  <TableCell>
                                    {items.heure_begin + ' - ' + items.heure_end}
                                  </TableCell>
                                  <TableCell>
                                    {items.libelle === null || items.libelle === undefined ? `${items.depart}-${items.arriver}` : items.libelle}
                                  </TableCell>
                                  <TableCell>
                                    <Autocomplete
                                      multiple
                                      options={[...missionnaires, ...intervenantsoption]}
                                      getOptionLabel={(option) => option.nom}
                                      filterSelectedOptions
                                      onChange={(event, value) => handleChangeMissionary(event, value, agendaItem.id, index)}
                                      value={Array.isArray(items.user_id) ? items.user_id : []}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          size="small"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  {details[0].categtype === 'groupe' && (
                                    <TableCell>
                                      <Autocomplete
                                        multiple
                                        options={missionnaires}
                                        getOptionLabel={(option) => option.nom}
                                        filterSelectedOptions
                                        onChange={(event, value) => handleChangeParticipant(event, value, agendaItem.id, index)}
                                        value={items.particip || missionnaires}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell>
                                    <Autocomplete
                                      options={details[0].transport || []}
                                      getOptionLabel={(option) => option.designation}
                                      filterSelectedOptions
                                      onChange={(event, value) => handleChangetransport(event, value, agendaItem.id, index)}
                                      value={items.transport || null}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          size="small"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      variant="outlined"
                                      value={items.observation || ''}
                                      name="observation"
                                      onChange={(event) => handleChangeObservation(event, agendaItem.id, index)}
                                    />
                                  </TableCell>   
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    );
                  }
                  return null; 
                })
              ))}
              
              <Grid item xs={2}>
                <Typography variant="body1" align="left">Annexe :</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  type="file"
                  inputProps={{ accept: ".pdf,.rar,.zip" }} 
                  fullWidth
                  variant="outlined"
                  onChange={handleFileChange}
                />
                <Typography variant="body2" color="textSecondary">
                  Vous pouvez télécharger des fichiers PDF, ou un fichier compressé (.rar ou .zip) contenant plusieurs PDF.
                </Typography>
                {error && <Typography color="error">{error}</Typography>}
              </Grid>

              <Grid item xs={6}></Grid>
              
              <Grid item xs={12} justifyContent="left">
                <Button 
                  variant="contained" 
                  color="primary"   
                  style={{ 
                    marginRight: '30px', 
                    marginBottom: '40px',
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: 600
                  }}
                  onClick={handleretour} 
                  autoFocus
                >
                  Retour
                </Button> 
                
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={() => handlevalidate("validation")}
                  loading={loading} 
                  loadingPosition="start" 
                  style={{ 
                    marginRight: '30px', 
                    marginBottom: '40px',
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: 600
                  }}
                  autoFocus
                >
                  Suivant
                </LoadingButton>
                
                <Button 
                  variant="contained" 
                  color="secondary" 
                  style={{
                    marginBottom:"40px",  
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: 600
                  }} 
                  onClick={handleClose} 
                  autoFocus
                >
                  Annuler
                </Button> 
              </Grid>
            </Grid>
          ) : (
            <Typography variant="body1">Aucune donnée disponible</Typography>
          )}

          <Spacer y={3} />
        </Paper>

        {/* ===== Dialog kilométrage - CORRIGÉ (plus de <p> imbriqué) ===== */}
        <Dialog
          open={openDialogKilometer.open}
          onClose={() => setOpenDialogKilometer({ ...openDialogKilometer, open: false })}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent>
            <Box sx={{ textAlign: 'center' }}>
              <Spacer y={2} />
              <Alert severity="info">
                <Typography component="span" variant="body1" sx={{ fontWeight: 'bold' }}>
                  Voulez-vous saisir les kilométrages prévisionnels pour la mission ?
                </Typography>
              </Alert>
              <Spacer y={2} />
            </Box>
          </DialogContent>
          <DialogActions>
            <Spacer y={2} />
            <Button 
              variant="contained" 
              color="secondary" 
              onClick={() => {
                setOpenDialogKilometer({ ...openDialogKilometer, open: false })
                navigate('/mission/planning_mission'); 
              }}
            >
              Plus tard  
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenDialogKilometer({ ...openDialogKilometer, open: false });
                navigate(`/mission/time_sheet/add/Planning/${openDialogKilometer.mission_planning_id}`);
              }}
              loading={loading}
              loadingPosition="start"
            >
              saisir les kilométrages
            </LoadingButton>
          </DialogActions>
        </Dialog>
        
        {/* ===== Dialog erreur dates - CORRIGÉ (plus de <p> imbriqué) ===== */}
        <div>
          <Dialog
            open={erroraffiche}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClosealert}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle style={{ padding: 0 }}>
              <div style={noteStyleerreur}>
                <Typography component="span" sx={{ margin: 0, display: 'block' }}>
                  Incohérences de dates
                </Typography>          
              </div>
            </DialogTitle>
            <DialogContent>
              <Box id="alert-dialog-slide-description">
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Les dates de la mission ne correspondent pas aux dates des agendas sélectionnés.
                </Typography>
                <Typography variant="body2">
                  Veuillez vérifier que tous les agendas ont les mêmes dates que la mission.
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="secondary" onClick={handleClosealert}>
                D'accord, compris
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </MainContainer>
    </React.Fragment>
  );
}